<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">GANANCIAS OFRENDAS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>INFORME GANANCIAS OFRENDAS</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3">
          <span><strong>PARROQUIA: </strong></span>
          <Dropdown
            v-model="sucursalSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
            :filter="true"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <span><strong>NOMBRE PRODUCTO: </strong></span>
          <div class="p-inputgroup">
            <AutoComplete
              field="descripcion"
              v-model="productoSelected"
              :suggestions="productosListadoFiltrado"
              @keyup.enter="buscarProducto($event)"
              placeholder="Escriba Nombre Producto"
            >
            </AutoComplete>
            <Button
              :disabled="!productoSelected"
              icon="pi pi-search"
              class="p-button-warning"
              v-tooltip.top="'Buscar Producto'"
              @click="buscarProducto($event)"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3" v-if="false">
          <span><strong>MARCA: </strong></span>
          <AutoComplete
            :dropdown="true"
            field="nombre"
            v-model="laboratorioSelected"
            :suggestions="laboratoriosListadoFiltrado"
            @complete="buscarLaboratorio($event)"
            placeholder="Buscar Marca"
          >
            <template #item="slotProps">
              <div>
                {{ slotProps.item.nombre }}
              </div>
            </template>
          </AutoComplete>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>USUARIOS/CAJEROS</strong></span>
          <Dropdown
            v-model="userSeleccionado"
            :options="users"
            optionLabel="name"
            optionValue="id"
            :filter="true"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>FECHA INICIO: </strong></span>
          <InputText
            v-model="fecha_venta_desde"
            type="date"
            class="p-inputtext-ms"
          />
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>FECHA FIN: </strong></span>
          <InputText
            v-model="fecha_venta_hasta"
            type="date"
            class="p-inputtext-ms"
          />
        </div>
        <div class="field col-12 md:col-3" v-show="false">
          <span><strong>SELECCIONE MES: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="mes_seleccionado"
              :options="meses"
              optionLabel="label"
              placeholder="Seleccione un mes"
            />
          </div>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="APLICAR FILTROS"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Aplicar Filtros de Busqueda'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>
    <div class="mt-2 style_card">
      <div class="p-fluid formgrid grid">
        <table class="table table-bordered table-striped" style="width: 100%">
          <tr>
            <th class="text-center">
              TOTAL OFRENDAS:
              <span class="p-badge p-badge-blue p-mr-2" style="font-size: 1rem"
                >{{
                  convertirNumeroGermanicFormat(total_ventas ?? 0)
                }}
                Bs.</span
              >
            </th>
            <th class="text-center">
              TOTAL COMPRAS:
              <span class="p-badge p-badge-blue p-mr-2" style="font-size: 1rem"
                >{{
                  convertirNumeroGermanicFormat(total_compras ?? 0)
                }}
                Bs.</span
              >
            </th>
            <th class="text-center" v-if="ventas_ganancias_creditos > 0">
              OFRENDAS CR&Eacute;DITO:
              <span
                class="p-badge p-badge-danger p-mr-2"
                style="font-size: 1rem"
                >{{
                  convertirNumeroGermanicFormat(ventas_ganancias_creditos ?? 0)
                }}
                Bs.</span
              >
            </th>
            <th class="text-center" v-if="total_ventas_descuentos > 0">
              TOTAL DESCUENTOS:
              <span
                class="p-badge p-badge-danger p-mr-2"
                style="font-size: 1rem"
                >{{
                  convertirNumeroGermanicFormat(total_ventas_descuentos ?? 0)
                }}
                Bs.</span
              >
            </th>
            <th class="text-center">
              GANANCIAS OFRENDAS:
              <span
                class="p-badge p-badge-success p-mr-2"
                style="font-size: 1rem"
                >{{
                  convertirNumeroGermanicFormat(total_ganancias_ventas)
                }}
                Bs.</span
              >
            </th>
          </tr>
        </table>
      </div>
    </div>
    <div
      class="field col-12 md:col-12 mt-2 mb-0"
      v-if="nombre_sucursal"
      style="font-size: 1.2rem"
    >
      <span class="text-left"
        ><strong>OFRENDAS REALIZADAS EN: </strong>{{ nombre_sucursal }}</span
      >
    </div>
    <div class="mt-2">
      <DataTable
        ref="reporte_ganancias_ventas"
        key="id"
        :value="ventasConDesglose"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm"
        :filters="buscar"
        responsive="true"
        stripedRows
        showGridlines
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar..."
              />
            </span>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <!-- v-if="'R_Ganancias DescargarPDF' in auth.user.permissions" -->
              <Button
                v-if="false"
                label="PDF Imprimir"
                icon="pi pi-file-pdf"
                class="p-button-outlined p-button-danger mr-2"
                v-tooltip.top="'Imprimir Reporte PDF'"
                :loading="generandoPDF"
                :disabled="generandoPDF"
                @click="generarPDF"
              />
            </span>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'R_Ganancias DescargarEXCEL' in auth.user.permissions"
                label="EXCEL Exportar"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success"
                v-tooltip.top="'Imprimir Reporte Excel'"
                :loading="exportando"
                :disabled="exportando"
                @click="exportVentas"
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>

        <template #empty>
          <span
            class="flex align-items-center justify-content-center p-invalid"
          >
            Debe Aplicar Filtros para ver Resultados!
          </span>
        </template>

        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>

        <Column field="id_venta" header="COD">
          <template #body="{ data }">
            <span v-if="data.mostrarEncabezado">{{ data.id_venta }}</span>
          </template>
        </Column>

        <Column field="fecha_venta" header="FECHA">
          <template #body="{ data }">
            <span v-if="data.mostrarEncabezado">{{ data.fecha_venta }}</span>
          </template>
        </Column>

        <Column
          field="nombre_sucursal"
          header="PARROQUIA"
          v-if="sucursales.length > 2 && !nombre_sucursal"
        >
          <template #body="{ data }">
            <span v-if="data.mostrarEncabezado">{{
              data.nombre_sucursal
            }}</span>
          </template>
        </Column>

        <Column field="nombre_usuario" header="USUARIO">
          <template #body="{ data }">
            <span v-if="data.mostrarEncabezado">{{ data.nombre_usuario }}</span>
          </template>
        </Column>

        <Column
          field="nombre_producto"
          header="PRODUCTO/SERVICIO"
          style="font-weight: bold"
        >
          <template #body="{ data }">
            <div :class="{ 'pl-3': data.esDesglose }">
              <span v-if="data.esDesglose">↳ </span>
              {{ data.nombre_producto }}
            </div>
          </template>
        </Column>

        <Column field="cantidad" header="CANT." class="text-right"></Column>

        <Column field="precio_compra" header="P.ADQ" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio_compra ?? 0) }}
          </template>
        </Column>

        <Column field="precio_venta" header="OFRENDA" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio_venta ?? 0) }}
          </template>
        </Column>

        <Column field="ganancia_total" header="T.GAN." class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.ganancia_total ?? 0) }}
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import VentaService from "@/service/VentaService";
import SucursalService from "@/service/SucursalService";
import UserService from "@/service/UserService";
import ProductService from "@/service/ProductService";
import { useAuth } from "@/stores";
import { sum } from "lodash";

export default {
  data() {
    return {
      fecha_venta_desde: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      )
        .toISOString()
        .substring(0, 10),
      fecha_venta_hasta: new Date().toISOString().substring(0, 10),
      enviando: false,
      ventas_ganancias: [],
      ventasConDesglose: [],
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: "TODAS" }],
      userSeleccionado: 0,
      users: [{ id: 0, name: "TODOS" }],
      generandoPDF: false,
      exportando: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      productoSelected: null,
      productosListadoFiltrado: [],
      mes_seleccionado: null,
      meses: [
        { label: "ENERO", value: 1 },
        { label: "FEBRERO", value: 2 },
        { label: "MARZO", value: 3 },
        { label: "ABRIL", value: 4 },
        { label: "MAYO", value: 5 },
        { label: "JUNIO", value: 6 },
        { label: "JULIO", value: 7 },
        { label: "AGOSTO", value: 8 },
        { label: "SEPTIEMBRE", value: 9 },
        { label: "OCTUBRE", value: 10 },
        { label: "NOVIEMBRE", value: 11 },
        { label: "DICIEMBRE", value: 12 },
      ],
      mostrarModal: false,
      ventas_ganancias_creditos: 0,
      laboratorioSelected: null,
      laboratoriosListadoFiltrado: [],
      nombre_sucursal: "",
    };
  },
  ventaService: null,
  sucursalService: null,
  userService: null,
  auth: null,
  productService: null,
  created() {
    this.ventaService = new VentaService();
    this.sucursalService = new SucursalService();
    this.userService = new UserService();
    this.auth = useAuth();
    this.productService = new ProductService();
  },
  mounted() {
    this.cargarSucursales();
    this.cargarUsuarios();
  },
  computed: {
    total_ventas_descuentos() {
      let total = 0;
      this.ventas_ganancias.forEach((item) => {
        total += parseFloat(item.descuento_neto);
      });
      return total || 0;
    },
    total_ventas() {
      return sum(
        this.ventas_ganancias.map((item) => {
          return item.precio_venta * item.cantidad;
        })
      );
    },
    total_compras() {
      return sum(
        this.ventas_ganancias.map((item) => {
          return item.precio_compra * item.cantidad;
        })
      );
    },
    total_ganancias_ventas() {
      return (
        this.total_ventas -
        this.total_compras -
        this.ventas_ganancias_creditos -
        this.total_ventas_descuentos
      );
    },
  },
  methods: {
    agregarDesgloseCuria(ventas) {
      const ventasConDesglose = [];
      let ventaAnterior = null;

      ventas.forEach((venta) => {
        const esCuria = venta.nombre_producto
          .toLowerCase()
          .includes("derecho de curia");
        const montoTotal = venta.precio_venta * venta.cantidad;
        const gananciaTotal = venta.ganancia_total;

        // Determinar si es una nueva venta (no la misma que la anterior)
        const esNuevaVenta =
          ventaAnterior === null || venta.id_venta !== ventaAnterior.id_venta;

        if (esCuria) {
          // Item principal (90%)
          ventasConDesglose.push({
            ...venta,
            nombre_producto: `Derecho de Curia (90%)${
              venta.mes_curia ? " - " + venta.mes_curia : ""
            }`,
            precio_venta: (montoTotal * 0.9) / venta.cantidad,
            ganancia_total: gananciaTotal * 0.9,
            esDesglose: false,
            mostrarEncabezado: esNuevaVenta,
          });

          // Fondo del Clero (5%)
          ventasConDesglose.push({
            ...venta,
            id_venta: esNuevaVenta ? venta.id_venta : "",
            fecha_venta: esNuevaVenta ? venta.fecha_venta : "",
            nombre_sucursal: esNuevaVenta ? venta.nombre_sucursal : "",
            nombre_usuario: esNuevaVenta ? venta.nombre_usuario : "",
            nombre_producto: `Fondo del Clero (5%)${
              venta.mes_curia ? " - " + venta.mes_curia : ""
            }`,
            precio_venta: (montoTotal * 0.05) / venta.cantidad,
            ganancia_total: gananciaTotal * 0.05,
            esDesglose: true,
            mostrarEncabezado: false,
          });

          // Casa del Clero (5%)
          ventasConDesglose.push({
            ...venta,
            id_venta: "",
            fecha_venta: "",
            nombre_sucursal: "",
            nombre_usuario: "",
            nombre_producto: `Casa del Clero (5%)${
              venta.mes_curia ? " - " + venta.mes_curia : ""
            }`,
            precio_venta: (montoTotal * 0.05) / venta.cantidad,
            ganancia_total: gananciaTotal * 0.05,
            esDesglose: true,
            mostrarEncabezado: false,
          });
        } else {
          // Producto normal
          ventasConDesglose.push({
            ...venta,
            esDesglose: false,
            mostrarEncabezado: esNuevaVenta,
          });
        }

        ventaAnterior = venta;
      });

      return ventasConDesglose;
    },
    debeMostrarFila(itemActual, index) {
      if (index === 0) return true;

      const itemAnterior = this.ventas_ganancias[index - 1];
      return (
        itemActual.id_venta !== itemAnterior.id_venta ||
        itemActual.fecha_venta !== itemAnterior.fecha_venta ||
        itemActual.nombre_usuario !== itemAnterior.nombre_usuario
      );
    },
    buscarLaboratorio(event) {
      setTimeout(() => {
        this.productService
          .buscarLaboratorioXNombre({ texto: event.query })
          .then((response) => {
            this.laboratoriosListadoFiltrado = [...response.laboratorios];
          });
      }, 250);
    },
    buscarProducto() {
      let datos = {
        texto: this.productoSelected ?? "",
        sucursal_id: this.sucursalSelected,
      };
      this.productService
        .getProductoServicio(datos)
        .then((response) => {
          if (response.productos.length == 0) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No se encontraron productos",
              life: 3000,
            });
            this.productosListadoFiltrado = [];
            return;
          }
          this.productosListadoFiltrado = [...response.productos];
        })
        .catch((error) => console.log(error));
    },
    obtenerTotalVenta(precio_venta, cantidad, descuento_neto) {
      return precio_venta * cantidad - descuento_neto;
    },
    obtenerTotalCompra(precio_compra, cantidad) {
      return precio_compra * cantidad;
    },
    obtenerTotalGanancia(
      precio_venta,
      precio_compra,
      cantidad,
      descuento_neto
    ) {
      return (
        precio_venta * cantidad - precio_compra * cantidad - descuento_neto
      );
    },
    exportVentas() {
      if (this.ventas_ganancias.length > 0) {
        let datos = {
          sucursal_id: this.sucursalSelected,
          cajero_id: this.userSeleccionado,
          fecha_venta_desde: this.fecha_venta_desde,
          fecha_venta_hasta: this.fecha_venta_hasta,
          producto: this.productoSelected ? this.productoSelected.id : null,
          mes_seleccionado: this.mes_seleccionado
            ? this.mes_seleccionado.value
            : null,
          fabrica_id: this.laboratorioSelected
            ? this.laboratorioSelected.id
            : null,
          sucursales: this.auth.user?.sucursales ?? [],
        };
        if (this.exportando) return;
        this.exportando = true;
        this.ventaService.exportarRGananciasVentas(datos).then(() => {
          this.exportando = false;
          this.$toast.add({
            severity: "success",
            summary: "Exportación exitosa",
            detail: "Se ha exportado correctamente",
            life: 3000,
          });
        });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para exportar",
          life: 3000,
        });
      }
    },
    generarPDF() {
      if (this.ventas_ganancias.length > 0) {
        this.generandoPDF = true;
        let datos = {
          sucursal_id: this.sucursalSelected,
          cajero_id: this.userSeleccionado,
          fecha_venta_desde: this.fecha_venta_desde,
          fecha_venta_hasta: this.fecha_venta_hasta,
          producto: this.productoSelected ? this.productoSelected.id : null,
          mes_seleccionado: this.mes_seleccionado
            ? this.mes_seleccionado.value
            : null,
          fabrica_id: this.laboratorioSelected
            ? this.laboratorioSelected.id
            : null,
        };
        this.ventaService.imprimirRGananciasPDF(datos).then(() => {
          this.generandoPDF = false;
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: "Se genero el PDF correctamente",
            life: 3000,
          });
        });
      } else
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para generar el reporte",
          life: 3000,
        });
    },
    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        data.forEach((element) => {
          this.users.push(element);
        });
      });
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((data) => {
          let tiene_sucursal = this.auth.user?.sucursal_id;
          if (tiene_sucursal) {
            this.sucursales = data.filter(
              (sucursal) => sucursal.id === tiene_sucursal
            );
            this.sucursalSelected = tiene_sucursal;
          } else {
            this.sucursales = [{ id: 0, nombre: "TODAS" }, ...data];
            this.sucursalSelected = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    BuscarFiltro() {
      this.ventas_ganancias = [];
      this.enviando = true;
      this.cargarReporteVentas();
    },
    cargarReporteVentas() {
      let datos = {
        sucursal_id: this.sucursalSelected,
        cajero_id: this.userSeleccionado,
        fecha_venta_desde: this.fecha_venta_desde,
        fecha_venta_hasta: this.fecha_venta_hasta,
        producto: this.productoSelected ? this.productoSelected.id : null,
        mes_seleccionado: this.mes_seleccionado
          ? this.mes_seleccionado.value
          : null,
        fabrica_id: this.laboratorioSelected
          ? this.laboratorioSelected.id
          : null,
        sucursales: this.auth.user?.sucursales ?? [],
      };
      this.ventaService
        .filtrarGananciasVentas(datos)
        .then((data) => {
          this.ventas_ganancias = data.ventas_ganancias ?? [];
          this.ventas_ganancias_creditos = data.ventas_ganancias_creditos ?? 0;
          this.nombre_sucursal = data.nombre_sucursal;
          this.ventasConDesglose = this.agregarDesgloseCuria(
            this.ventas_ganancias
          );
          this.enviando = false;
        })
        .catch((error) => {
          this.enviando = false;
          console.log(error);
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}
.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}

.style_card {
  border: 1px solid #000000;
  border-bottom: 5px solid #000000;
}
.pl-3 {
  padding-left: 1rem;
}
</style>
